// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card_2wnx1","body":"Card_body_2GwDS","count":"Card_count_3ILrj"};